import logo from "./logo.svg";
import "./App.css";

// import Header from "./components/Header";
// import Footer from "./components/Footer";
// import Body from "./components/Body";
// import Dashboard from "./Pages/Dashboard";
import Router from "./components/Router";
//import ForCheck from "./Pages/ForCheck";
//import "antd/dist/antd.css";
import React, { useEffect } from "react";
import MainPageLeftDrawer from "./components/Pages/MainPageLeftDrawer";
//import O2RLogo from "./Images/O2RLogo.png";

//my change for check 6-1
//For Shrat
export const MyUrl = "https://apinewbi.o2rintelligence.com"; //https://localhost:7184 <-- //https://apinewbi.o2rintelligence.com
export const Redirect = `https://app.o2rintelligence.com`; //http://apinewbi.o2rintelligence.com //https://localhost:3000
//here we call data from o2r project
export const CallFromO2R = "https://app.o2rintelligence.com"; //https://localhost:7006 <--
export const ForLogOut = "https://app.o2rintelligence.com/";

//End For Shrat

//For Loacal
// export const MyUrl = "https://localhost:7184"; //https://localhost:7184
// export const Redirect = `https://app.o2rintelligence.com`; //http://apinewbi.o2rintelligence.com //https://localhost:3000
// //here we call data from o2r project
// export const CallFromO2R = "https://localhost:7006";
// export const ForLogOut = "http://localhost:3000/";
//End For Loacal

//For Axios
//https://localhost:7184
//http://103.54.56.73:90
//http://apinewbi.o2rintelligence.com

//For Redirect
//http://app.o2rintelligence.com/ --> if we want to Deploy it
//`http://localhost:3000`  --> Send you to o2r project to login page
function App() {
  // useEffect(() => {
  //   document.title = "O2R Intelligence"; // Change this to your desired name
  // }, []);
  // useEffect(() => {
  //   const icon = document.head.querySelector('link[rel="icon"]');
  //   icon.href = O2RLogo; // Change this to the URL of your custom icon file
  // }, []);

  //className="App-header"
  return (
    <div
      style={{
        //flex: 1,
        //  display: "flex", // For desktop should flex it  put for mobile when unable it (no flex)
        // paddingRight: "1%",
        display: "flex", // width > 766 ? "flex" : "",
        flexGrow: 1,
      }}
    >
      {/* <MainPageLeftDrawer /> */}
      <MainPageLeftDrawer />

      <div style={{ width: "100%" }}>
        <Router />
      </div>
    </div>
  );
}

export default App;

// ("use strict");

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-enterprise";
// import { AgGridReact } from "ag-grid-react";
// import React, { StrictMode, useCallback, useMemo, useState } from "react";
// import { createRoot } from "react-dom/client";

// var checkboxSelection = function (params) {
//   // we put checkbox on the name if we are not doing grouping
//   return params.api.getRowGroupColumns().length === 0;
// };

// var headerCheckboxSelection = function (params) {
//   // we put checkbox on the name if we are not doing grouping
//   return params.api.getRowGroupColumns().length === 0;
// };

// export default function App() {
//   const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
//   const gridStyle = useMemo(() => ({ height: 900, width: "100%" }), []);
//   const [rowData, setRowData] = useState();
//   const [columnDefs, setColumnDefs] = useState([
//     {
//       field: "athlete",
//       minWidth: 170,
//       checkboxSelection: checkboxSelection,
//       headerCheckboxSelection: headerCheckboxSelection,
//     },
//     { field: "age" },
//     { field: "country" },
//     { field: "year" },
//     { field: "date" },
//     { field: "sport" },
//     { field: "gold" },
//     { field: "silver" },
//     { field: "bronze" },
//     { field: "total" },
//   ]);
//   const autoGroupColumnDef = useMemo(() => {
//     return {
//       headerName: "Group",
//       minWidth: 170,
//       field: "athlete",
//       valueGetter: (params) => {
//         if (params.node.group) {
//           return params.node.key;
//         } else {
//           return params.data[params.colDef.field];
//         }
//       },
//       headerCheckboxSelection: true,
//       cellRenderer: "agGroupCellRenderer",
//       cellRendererParams: {
//         checkbox: true,
//       },
//     };
//   }, []);
//   const defaultColDef = useMemo(() => {
//     return {
//       editable: true,
//       enableRowGroup: true,
//       enablePivot: true,
//       enableValue: true,
//       filter: true,
//       flex: 1,
//       minWidth: 100,
//     };
//   }, []);

//   const onGridReady = useCallback((params) => {
//     fetch("https://www.ag-grid.com/example-assets/olympic-winners.json")
//       .then((resp) => resp.json())
//       .then((data) => setRowData(data));
//   }, []);

//   return (
//     <div style={containerStyle}>
//       <div style={gridStyle} className={"ag-theme-quartz"}>
//         <AgGridReact
//           rowData={rowData}
//           columnDefs={columnDefs}
//           autoGroupColumnDef={autoGroupColumnDef}
//           defaultColDef={defaultColDef}
//           suppressRowClickSelection={true}
//           groupSelectsChildren={true}
//           rowSelection={"multiple"}
//           rowGroupPanelShow={"always"}
//           pivotPanelShow={"always"}
//           pagination={true}
//           onGridReady={onGridReady}
//         />
//       </div>
//     </div>
//   );
// }
